import playback from './playback.js';
import recommendation from './recommendation.js';
import learnActions from './learnActions.js';

function experience(backendAxiosInstance) {
  return {
    ...playback(backendAxiosInstance),
    ...recommendation(backendAxiosInstance),
    ...learnActions(backendAxiosInstance)
  };
}

export { experience as default };
//# sourceMappingURL=index.js.map
